import axios from "axios";
import AuthService from '@/services/AuthService';

const instance = axios.create({
  baseURL: process.env.VUE_APP_DASHBOARD_API_URL,
});
export default {
    async getMestaStudentResults(query) {
        try {
            const response = await instance.get("getMestaStudentResults" +query);
            return response.data;
        } catch (error) {
            return error.response;
        }
    },
    
    async getTeacherResults(query) {
        try {
            const response = await instance.get("getTeacherResults" + query);
            return response.data;
        }
        catch (error) {
            return error.response;
        }
    },

    async getTopTeacherResults(query) {
        try {
            const response = await instance.get("getTopTeacherResults" + query);
            return response.data;
        }
        catch (error) {
            return error.response;
        }
    },

    async getJobSeekerResults(query) {
        try {
            const response = await instance.get("getJobSeekerResults"+query);
            return response.data.data;
        } catch (error) {
            return error.response;
        }
    },
    async getJobSeekerResultsAppraisal(query) {
        try {
            const response = await instance.get("getJobSeekerResultsAppraisal"+query);
            return response.data.data;
        } catch (error) {
            return error.response;
        }
    },
    async getJobSeekerResultsPiP(query) {
        try {
            const response = await instance.get("getJobSeekerResultsPiP"+query);
            return response.data.data;
        } catch (error) {
            return error.response;
        }
    },
    async getJobSeekerResultsTBD(query) {
        try {
            const response = await instance.get("getJobSeekerResultsTBD"+query);
            return response.data.data;
        } catch (error) {
            return error.response;
        }
    },
    async getChartData(query) {
        try {
            const response = await instance.get("dashboard/job-seeker"+query);
            return response.data;
        } catch (error) {
            return error.response;
        }
    },
    async viewDashboard(payload){
        try {
            const response = await instance.post("viewDashboard",payload);
            return response.data;
        } catch (error) {
            return error.response;
        }
    },
    async getChartCount(payload){
        try {
            const response = await instance.post("getChartCount",payload);
            return response.data;
        } catch (error) {
            return error.response;
        }
    },
    async getTrendlineChartData(requestBody) {
        console.log('in controlller',requestBody)
        try {
            const response = await instance.get("jobseeker-treadline-dashboard", {
             params: requestBody,
            });
            return response.data;
        } catch (error) {
           return error.response;
        }
    },
    async downloadTrendlineChartData(requestBody) {
        try {
            const response = await instance.get("jobseeker-treadline-dashboard/download", {
             params: requestBody,
            });
            return response.data;
        } catch (error) {
           return error.response;
        }
    },
    async getComparisonDashboardData(requestBody) {
        
        try {
            const response = await instance.get("jobseeker-comparison-dashboard", {
             params: requestBody,
        });
        console.log('response in controller',response)
            return response.data;
        } catch (error) {
           return error.response;
        }
    },
    
    async getMixpanelData (type,parameteres = {}){
            try{
                const response = await instance.get('/mixpanel/analytics/'+type,
                {
                    params: parameteres,
                    headers:{
                        'Authorization':AuthService.getToken()
                    }
                })
                return response;
            }
            catch (error){
                console.error ('Analytics service error:', error);
                throw error;
            }
    },
    async getVoltDashboardData(requestBody) {
        
        try {
            const response = await instance.get('/dashboard/vgos-dashboard', {
             params: requestBody,
        });
        console.log('response getVoltDashboardData',response)
            return response.data;
        } catch (error) {
           return error.response;
        }
    },
    async downloadVoltDashboardData(requestBody) {
        
        try {
            const response = await instance.get('/dashboard/download-vgos-dashboard', {
             params: requestBody,
        });
        console.log('response downloadVoltDashboardData',response)
            return response.data;
        } catch (error) {
           return error.response;
        }
    },
    

}